/* eslint-disable no-undef */
import React from 'react';
import { OptionStyle } from './style';

export default function AccessModeSincroniza({ value, modifyFunction, labelText }) {
  return (
    <OptionStyle>
      <p>{labelText}</p>
      <select name="accessModeSelect" value={value} onChange={(e) => modifyFunction(e.target.value)}>
        <option value="">Escolha uma opção</option>
        <option value={process.env.REACT_APP_USER_SINCRONIZA_ACCESS}>Prestador Sincroniza</option>
        <option value={process.env.REACT_APP_ADMIN_SINCRONIZA_ACCESS}>Administrador Sincroniza</option>
      </select>
    </OptionStyle>
  );
}
